import { render, staticRenderFns } from "./TrainSearch.vue?vue&type=template&id=20c7d6ac&scoped=true&"
import script from "./TrainSearch.vue?vue&type=script&lang=js&"
export * from "./TrainSearch.vue?vue&type=script&lang=js&"
import style0 from "./TrainSearch.vue?vue&type=style&index=0&id=20c7d6ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c7d6ac",
  null
  
)

export default component.exports